import type { ComponentChildren, FunctionComponent } from 'preact';
import styles from './ThemeProvider.module.css';

export const ThemeProvider: FunctionComponent<{ children: ComponentChildren }> = ({ children }) => {
  return <div class={styles.root}>{children}</div>;
};
